import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Project } from '../../interfaces/project.interface';
import { projects } from '../../content/projects';
import { Post } from '../../interfaces/post.interface';
import { PostService } from '../../services/post.service';
import { navigateWithFadingAnimation } from '../../utilities/utilities.utility';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  @ViewChild('homeContainer') homeContainerElement: ElementRef<HTMLElement>;
  public projects: Project[];
  public posts: Observable<Post[]>;

  constructor(
    private postService: PostService,
    private router: Router
  ) {
    this.projects = projects;

    this.posts = postService.getLatestPosts(3);
  }

  public navigate(elementToFade: ElementRef<HTMLElement>, navigationParams: [string, string]): void {
    navigateWithFadingAnimation(elementToFade, navigationParams, this.router);
  }
}
